<div class="where_to_deliver_container pointer flex_column flex_align_center" (click)="selectAddress()"
  [class.unsetPaddings]="fromTop"
>
  <div class="title font_13 bold_600 flex_align_center">
    <img src="assets/images/icons/location_Icon_for_mat_options.svg">
    <span class="ml_4"> {{'navbar.address_of_delivery' | translate}} </span>
  </div>
  <div class="address bold_700 font_15">
    {{selectedAddressName || ('navbar.select_address' | translate)}}
  </div>
</div>
